import { motion } from 'motion/react';

interface TechStackMarqueeProps {
  logos?: string[];
  title?: string;
  className?: string;
  onClick?: () => void;
}

const defaultLogos = [
  "https://framerusercontent.com/images/Fb1ZWQQvjMlUTaqBOQ7EpnhJ6mY.png?scale-down-to=112&format=webp&quality=50",
  "https://framerusercontent.com/images/sQfHoo0AdftsMRfAmgFfd1MM.png?scale-down-to=112&format=webp&quality=50",
  "https://framerusercontent.com/images/rGb5A8ifWgcU5A4LbMZqXmceS54.png?scale-down-to=112&format=webp&quality=50",
  "https://framerusercontent.com/images/29LJ2HGXlNwwFRmDoEbok6cWGx0.png?scale-down-to=112&format=webp&quality=50",
  "https://framerusercontent.com/images/DkItwEnTHX52f2vgaDa1FNsLp7Y.png?scale-down-to=112&format=webp&quality=50",
  "https://framerusercontent.com/images/ieEL1Ycb6GJ2VPkk3VsJNA1EW5I.png?scale-down-to=112&format=webp&quality=50",
  "https://framerusercontent.com/images/MlZQzPlCc8fYz7MMOjp8jMkvY9w.png?scale-down-to=112&format=webp&quality=50",
  "https://framerusercontent.com/images/38Ygx23Yqq0BgmnRAsU2ETYB8.jpeg?scale-down-to=112&format=webp&quality=50",
  "https://framerusercontent.com/images/DvWfurVeTAhsHcVQppEt73HAdV0.png?scale-down-to=112&format=webp&quality=50",
  "https://framerusercontent.com/images/WFn7fwTcPEQ7g4RyPXPwEvGbecM.png?scale-down-to=112&format=webp&quality=50",
  "https://framerusercontent.com/images/q8FwRey29iSM87nqoUK9BF3AHNQ.jpeg?scale-down-to=112&format=webp&quality=50",
  "https://framerusercontent.com/images/HmBMlHkeEZXQBLyDiqXgKUV3Oo.png?scale-down-to=112&format=webp&quality=50",
  "https://framerusercontent.com/images/phNbAHU2lMtd8d4kc7TRgz43eA.jpeg?scale-down-to=112&format=webp&quality=50",
  "https://framerusercontent.com/images/oFXE99WkeFswsYM9oXHs1MLx2sY.png?scale-down-to=112&format=webp&quality=50",
  "https://framerusercontent.com/images/6Th9nVNOYcL2yHtb7YuQbJuhh8.png?scale-down-to=112&format=webp&quality=50",
  "https://framerusercontent.com/images/ZgQbgOaRVurfvivQVO3lZpaRqtg.png?scale-down-to=112&format=webp&quality=50",
  "https://framerusercontent.com/images/0fhknQuRLcp09zfUHpEnGiIDLqA.png?scale-down-to=112&format=webp&quality=50",
  "https://framerusercontent.com/images/wt4YYXhTX7PA3X9QTaVI2g9N5g.png?scale-down-to=112&format=webp&quality=50",
  "https://framerusercontent.com/images/KGL1tWLXitoGsvoQhMz2jsuDcjc.png?scale-down-to=112&format=webp&quality=50",
];

export const TechStackMarquee = ({ 
  logos = defaultLogos, 
  title = "Tech Stack",
  className = "",
  onClick
}: TechStackMarqueeProps) => {
  const row1Logos = logos.slice(0, Math.ceil(logos.length / 2));
  const row2Logos = logos.slice(Math.ceil(logos.length / 2));

  return (
    <motion.div 
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: 0.5 }}
      onClick={onClick}
      className={`bg-white rounded-[32px] p-8 md:p-10 flex flex-col justify-between shadow-[0_2px_10px_rgba(0,0,0,0.04)] border border-gray-100 relative overflow-hidden group cursor-pointer ${className}`}
    >
      <div className="flex flex-col gap-6 mb-8 mask-horizontal">
        {/* Row 1 */}
        <div className="relative flex overflow-hidden">
          <motion.div 
            animate={{ x: ["0%", "-50%"] }}
            transition={{ duration: 20, repeat: Infinity, ease: "linear" }}
            className="flex gap-4 whitespace-nowrap"
          >
            {[...row1Logos, ...row1Logos].map((logo, i) => (
              <div key={i} className="w-14 h-14 rounded-full bg-white shadow-sm border border-gray-50 flex items-center justify-center overflow-hidden shrink-0">
                <img src={logo} alt="Tech logo" className="w-full h-full object-cover" referrerPolicy="no-referrer" />
              </div>
            ))}
          </motion.div>
        </div>

        {/* Row 2 (Reverse) */}
        <div className="relative flex overflow-hidden">
          <motion.div 
            animate={{ x: ["-50%", "0%"] }}
            transition={{ duration: 25, repeat: Infinity, ease: "linear" }}
            className="flex gap-4 whitespace-nowrap"
          >
            {[...row2Logos, ...row2Logos].map((logo, i) => (
              <div key={i} className="w-14 h-14 rounded-full bg-white shadow-sm border border-gray-50 flex items-center justify-center overflow-hidden shrink-0">
                <img src={logo} alt="Tech logo" className="w-full h-full object-cover" referrerPolicy="no-referrer" />
              </div>
            ))}
          </motion.div>
        </div>
      </div>
      <h2 className="text-[2rem] font-bold text-[#323232]">{title}</h2>
    </motion.div>
  );
};
